<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script charset="utf-8" src="https://map.qq.com/api/gljs?v=1.exp&key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77"></script>
<script type="text/javascript" src="//api.map.baidu.com/api?v=2.0&ak=SDYSm7Gn92GWk27TPTqWmn6GVdqu99qc"></script>
<script>
import "./assets/css/quill.core.css";
import "./assets/css/quill.snow.css";
import "./assets/css/quill.bubble.css";
import "./assets/css/quill-editer.scss";

export default {
  name: "App",
};
</script>

<style lang="scss">
@import "src/assets/css/nekomata.scss";
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue